import { gql, useQuery } from "@apollo/client";
import moment from "moment";
import Link from "next/link";
import { useRouter } from "next/router";

import Loader from "@/components/common/Loader/Loader";
import PageHeader from "@/components/PageHeader";
import Seo from "@/components/seo";
import styles from "@/styles/History.module.css";

const MONTH_TO_INT = {
  jan: 1,
  feb: 2,
  mar: 3,
  apr: 4,
  may: 5,
  jun: 6,
  jul: 7,
  aug: 8,
  sep: 9,
  oct: 10,
  nov: 11,
  dec: 12,
};

function SongHistoryPage() {
  const router = useRouter();
  const { data } = useQuery(pageQuery, {
    variables: {
      year: router.query.year,
      month:
        router.query.month?.toLowerCase() in MONTH_TO_INT
          ? MONTH_TO_INT[router.query.month.toLowerCase()]
          : router.query.month,
      day: router.query.day,
    },
  });

  if (!data) return <Loader />;

  let date = moment(data.history.date);
  const previousDate = moment(date).subtract(1, "days");
  const nextDate = moment(date).add(1, "days");
  const navigation = (
    <div className={styles.dayNav}>
      <Link
        href={`/history/${previousDate.year()}/${
          previousDate.month() + 1
        }/${previousDate.date()}/`}
        className={styles.navLink}
      >
        <span className={styles.navEyebrow}>Previous day</span>
        <span className={styles.navDate}>
          {previousDate.format("MMMM D, YYYY")}
        </span>
      </Link>
      <Link
        href={`/history/${nextDate.year()}/${
          nextDate.month() + 1
        }/${nextDate.date()}/`}
        className={styles.navLink}
      >
        <span className={styles.navEyebrow}>Next day</span>
        <span className={styles.navDate}>
          {nextDate.format("MMMM D, YYYY")}
        </span>
      </Link>
    </div>
  );

  return (
    <div className={`container ${styles.page}`}>
      <Seo title={`${date.format("MMMM D, YYYY")} | History`} />
      <header className={styles.header}>
        <PageHeader>Song History - {date.format("MMMM D, YYYY")}</PageHeader>
      </header>
      {navigation}
      {data.history.history.length ? (
        <ul className={styles.list}>
          {data.history.history.map((history, i) => (
            <li key={i} className={styles.row}>
              <span className={styles.time}>
                {moment(history.timestamp).format("h:mma")}
              </span>
              <span className={styles.song}>{history.song}</span>
            </li>
          ))}
        </ul>
      ) : (
        <p className={styles.empty}>There&apos;s nothing!</p>
      )}
      {navigation}
    </div>
  );
}

export default SongHistoryPage;

const pageQuery = gql`
  query SongHistory($year: Int, $month: Int, $day: Int) {
    history(year: $year, month: $month, day: $day) {
      date
      history {
        timestamp
        song
      }
    }
  }
`;
